export default {
  "slots": {
    "modal": "sm:max-w-3xl sm:h-[28rem]",
    "input": "[&>input]:text-base/5"
  }
}